import { Box, Table, TableBody, TableRow } from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'
import { useAppSelector } from '../../store/redux/hooks'
import { getCurrentUser } from '../../store/redux/reducers/currentUserSlice'
import { ScheduleTableSection } from '../ScheduleView/ScheduleTableSection'
import MonthPicker from '../../components/MonthPicker/ReduxMonthPicker'
import { ListAlt } from '@mui/icons-material'
import MasonryTileTitle from '../../components/Masonry/MasonryTileTitle'
import { StyledScheduleStickyTitle } from '../../styles/ScheduleViewStyles'
import MasonryTile from '../../components/Masonry/MasonryTile'
import ScheduleTableHeader from '../ScheduleView/ScheduleTable.tsx/ScheduleTableHeader'
import { getHeaderCells } from '../../store/utils/getScheduleTableCells'
import { StyledTableCell } from '../../styles/TableStyles'
import { WorkDay } from '../../store/types'
import { PlannedHours } from '../../store/redux/reducers/scheduleDateSlice'

const MasonryTileHoursHome = ({ hours, worklog }: { hours: PlannedHours; worklog?: WorkDay[] }) => {
  const [selectedSections] = useState<string[]>([])
  const [openedSection] = useState<string>('')
  useAppSelector(state => getCurrentUser(state))
  const [isEditable] = useState(false)

  return (
    <MasonryTile 
      sx={{ 
        width: '100%', 
        overflowX: 'auto', 
        paddingX: { xs: '7px !important', sm: '16px !important' , md: '24px !important' } }}>
      <StyledScheduleStickyTitle sx={{ height: { xs: '71px', sm: '46px' } }}>
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: { xs: 'center', sm: 'space-between' },
            alignItems: { xs: 'center', sm: 'initial' },
            width: '100%',
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <MasonryTileTitle title={t('page.schedule.summary')} icon={ListAlt} />
          <MonthPicker />
        </Box>
      </StyledScheduleStickyTitle>
      <Table
        size="small"
        aria-label="collapsible table"
        stickyHeader
        sx={{ borderCollapse: 'collapse', borderSpacing: '0px 4px', height: '100%' }}
      >
        <caption
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: '0',
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            border: '0',
          }}
        >
          {t('page.schedule.summary')}
        </caption>
        <ScheduleTableHeader cells={getHeaderCells('summary')} />
        <TableBody>
          <TableRow>
            <StyledTableCell colSpan={getHeaderCells('summary').length} align="center" height={1} />
          </TableRow>
          {Object.keys(hours).map((date, index) => (
            <ScheduleTableSection
              key={index}
              date={date}
              intervals={hours[date]}
              isOpen={openedSection === date}
              isSelected={selectedSections.includes(date)}
              isEditable={isEditable}
              onClick={() => {}}
              onClickAway={() => {}}
              addInterval={() => {}}
              deleteInterval={_ => {}}
              editInterval={() => true}
              worklogHours={worklog?.find(workDay => workDay.date === date) || undefined}
              isPlannedHours={false}
              variant="summary"
              cancel={() => {}}
              setIsEditable={_ => {}}
              save={() => {}}
            />
          ))}
        </TableBody>
      </Table>
    </MasonryTile>
  )
}

export default MasonryTileHoursHome
